import { PayloadAction, createSlice } from "@reduxjs/toolkit"
import { AppThunk } from "./app";
import api from "./api";
import API_URL from "../config/ApiUrl";

interface NetworkProviderState {
    status: []
}
const initialState = {
    status: []
} as NetworkProviderState

const NetworkProviderSlice = createSlice({
    name: 'NetworkProvider',
    initialState,
    reducers: {
        setStatus: (state, action: PayloadAction<any>) => {
            state.status = action.payload;
        }
    }
})
export const { setStatus } = NetworkProviderSlice.actions;

export const fetchListNetworkProvider = (payload?: any): AppThunk<any> => async () => {
    try {
        const resp = await api.post(API_URL.NETWORK_PROVIDER.LIST, payload);
        return Promise.resolve(resp.data.data)
    } catch (error: any) {
        return Promise.reject(error.data)
    }
}
export const editNetworkProvider =
    (payload?: any): AppThunk<any> =>
        async (dispatch) => {
            try {
                const response = await api.post(API_URL.NETWORK_PROVIDER.EDIT, payload);
                return Promise.resolve(response.data);
            } catch (error: any) {
                return Promise.reject(error.data);
            }
        };
export const addNetworkProvider = (payload?: any): AppThunk<any> =>
    async (dispatch) => {
        try {
            const response = await api.post(API_URL.NETWORK_PROVIDER.ADD, payload);
            return Promise.resolve(response.data);
        } catch (error: any) {
            return Promise.reject(error.data);
        }
    };
export const deleteNetworkProvider =
    (payload?: any): AppThunk<any> =>
        async (dispatch) => {
            try {
                const response = await api.post(API_URL.NETWORK_PROVIDER.DELETE, payload);
                return Promise.resolve(response.data);
            } catch (error: any) {
                return Promise.reject(error.data);
            }
        };

export default NetworkProviderSlice.reducer